import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  label: {
    defaultMessage: 'Loading',
    id: 'LoadingSpinner.label',
  },
  initAis: {
    defaultMessage: 'Taking you to connect to {providerName}, please wait...',
    id: 'LoadingSpinner.initAis',
  },
  initPis: {
    defaultMessage: 'Taking you to confirm your payment, please wait...',
    id: 'LoadingSpinner.initPis',
  },
});
